export const USER_LOGIN_RESET = "USER_LOGIN_RESET";
export const USER_LOGIN_REQUEST = "USER_LOGIN_REQUEST";
export const USER_LOGIN_SUCCESS = "USER_LOGIN_SUCCESS";
export const USER_LOGIN_FAIL = "USER_LOGIN_FAIL";

export const USER_REGISTRATION_RESET = "USER_REGISTRATION_RESET";
export const USER_REGISTRATION_REQUEST = "USER_REGISTRATION_REQUEST";
export const USER_REGISTRATION_SUCCESS = "USER_REGISTRATION_SUCCESS";
export const USER_REGISTRATION_FAIL = "USER_REGISTRATION_FAIL";

export const USER_FORGOT_PASSWORD_RESET = "USER_FORGOT_PASSWORD_RESET";
export const USER_FORGOT_PASSWORD_REQUEST = "USER_FORGOT_PASSWORD_REQUEST";
export const USER_FORGOT_PASSWORD_SUCCESS = "USER_FORGOT_PASSWORD_SUCCESS";
export const USER_FORGOT_PASSWORD_FAIL = "USER_FORGOT_PASSWORD_FAIL";

export const USER_RESET_PASSWORD_RESET = "USER_RESET_PASSWORD_RESET";
export const USER_RESET_PASSWORD_REQUEST = "USER_RESET_PASSWORD_REQUEST";
export const USER_RESET_PASSWORD_SUCCESS = "USER_RESET_PASSWORD_SUCCESS";
export const USER_RESET_PASSWORD_FAIL = "USER_RESET_PASSWORD_FAIL";

export const UPDATE_PROFILE_RESET = "UPDATE_PROFILE_RESET";
export const UPDATE_PROFILE_REQUEST = "UPDATE_PROFILE_REQUEST";
export const UPDATE_PROFILE_SUCCESS = "UPDATE_PROFILE_SUCCESS";
export const UPDATE_PROFILE_FAIL = "UPDATE_PROFILE_FAIL";

export const CHANGE_PASSWORD_RESET = "CHANGE_PASSWORD_RESET";
export const CHANGE_PASSWORD_REQUEST = "CHANGE_PASSWORD_REQUEST";
export const CHANGE_PASSWORD_SUCCESS = "CHANGE_PASSWORD_SUCCESS";
export const CHANGE_PASSWORD_FAIL = "CHANGE_PASSWORD_FAIL";

export const USER_SETTING_RESET = "USER_SETTING_RESET";
export const USER_SETTING_REQUEST = "USER_SETTING_REQUEST";
export const USER_SETTING_SUCCESS = "USER_SETTING_SUCCESS";
export const USER_SETTING_FAIL = "USER_SETTING_FAIL";

export const USER_GET_PROFILE_RESET = "USER_GET_PROFILE_RESET";
export const USER_GET_PROFILE_REQUEST = "USER_GET_PROFILE_REQUEST";
export const USER_GET_PROFILE_SUCCESS = "USER_GET_PROFILE_SUCCESS";
export const USER_GET_PROFILE_FAIL = "USER_GET_PROFILE_FAIL";

export const GET_ORDERS_RESET = "GET_ORDERS_RESET";
export const GET_ORDERS_REQUEST = "GET_ORDERS_REQUEST";
export const GET_ORDERS_SUCCESS = "GET_ORDERS_SUCCESS";
export const GET_ORDERS_FAIL = "GET_ORDERS_FAIL";

export const ORDER_DETAIL_RESET = "ORDER_DETAIL_RESET";
export const ORDER_DETAIL_REQUEST = "ORDER_DETAIL_REQUEST";
export const ORDER_DETAIL_SUCCESS = "ORDER_DETAIL_SUCCESS";
export const ORDER_DETAIL_FAIL = "ORDER_DETAIL_FAIL";

export const GET_ITEMS_RESET = "GET_ITEMS_RESET";
export const GET_ITEMS_REQUEST = "GET_ITEMS_REQUEST";
export const GET_ITEMS_SUCCESS = "GET_ITEMS_SUCCESS";
export const GET_ITEMS_FAIL = "GET_ITEMS_FAIL";